<div class="p-10">
    <form nz-form nz-row [formGroup]="adjustVoidTimesheetForm" class="ppl-p0 mt-2">
        <table class="table">
            <thead>
                <tr>
                    @if(actionType === 'adjustTimesheet' || actionType === 'resurrectTimesheet') {
                    <th style="background-color: #a8e4e14d; width: 10%;"></th>
                    }
                    @if(actionType === 'adjustTimesheet' || actionType === 'resurrectTimesheet') {
                    <th style="background-color: #a8e4e14d; width: 15%;">Service Date</th>
                    }
                    @if(actionType === 'adjustTimesheet' || actionType === 'adjustAllTimesheet' || actionType ===
                    'resurrectTimesheet') {
                    <th style="background-color: #a8e4e14d; width: 20%;">Service Description</th>
                    }
                    @if(actionType === 'adjustTimesheet' || actionType === 'resurrectTimesheet') {
                    <th style="background-color: #a8e4e14d; width: 10%;">Time In</th>
                    <th style="background-color: #a8e4e14d; width: 10%;">Time Out</th>
                    <th style="background-color: #a8e4e14d; width: 10%;">Billed Units (15 Mins increment)</th>
                    }
                    @if (source == 'billing' && actionType == 'adjustAllBillings') {
                    <th style="background-color: #a8e4e14d; width: 15%;">MCO Name</th>
                    }
                    <th style="background-color: #a8e4e14d; width: 25%;">{{this.reasonText}} *</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    @if(actionType === 'adjustTimesheet' || actionType === 'resurrectTimesheet') {
                    <td>
                        <div class="pt-1"><span><b>New values</b></span></div>
                        <div class="pt-5"><span><b>Previous values</b></span></div>
                    </td>
                    }
                    @if(actionType === 'adjustTimesheet' || actionType === 'resurrectTimesheet') {
                    <td>
                        <nz-date-picker formControlName="serviceDate" id="serviceDate" nzPlaceHolder="Service Date"
                            [nzFormat]="'MM/dd/yyyy'" nzAllowClear="false"
                            style="width: 100%; height: 32px"></nz-date-picker>
                        <div class="pt-4 pl-5"><span>{{timesheetData?.serviceDate}}</span></div>
                    </td>
                    }
                    @if(actionType === 'adjustTimesheet' || actionType === 'adjustAllTimesheet' || actionType ===
                    'resurrectTimesheet') {
                    <td>
                        <div style="width: 100%;" class="filters" [ngClass]="{ 'error': adjustVoidTimesheetForm.get('serviceCode')?.invalid && adjustVoidTimesheetForm.get('serviceCode')?.touched }">
                            <ppl-dropdown-select formControlName="serviceCode" id="serviceCode" placeholder="Service Code"
                            [options]="serviceCodes" [optionLabel]="'lkpValueName'">
                            </ppl-dropdown-select>
                        </div>
                        <div style="margin-left: 8px; margin-right: 8px;width: 100%;"
                            *ngIf="adjustVoidTimesheetForm.get('serviceCode')?.invalid && adjustVoidTimesheetForm.get('serviceCode')?.touched">
                            <div class="error-message">Please select a service code</div>
                        </div>

                        <div class="pt-4 pl-3"><span>{{timesheetData?.serviceCode?.lkpValueName}}</span></div>
                    </td>
                    }
                    @if(actionType === 'adjustTimesheet' || actionType === 'resurrectTimesheet') {
                    <td>
                        <div [ngClass]="{ 'error-border': adjustVoidTimesheetForm.get('timeIn')?.errors?.['customError'] }">
                            <ppl-timepicker formControlName="timeIn" id="timeIn" [ariaLabel]="'Time In'"
                            [placeholder]="'HH:MM AM/PM'"></ppl-timepicker>
                        </div>
                        @if(actionType === 'adjustTimesheet' || actionType === 'resurrectTimesheet') {
                        <div class="pt-4 pl-2"><span>{{timesheetData?.timeIn}}</span></div>
                        }
                        <div style="margin-left: 8px; margin-right: 8px;width: 100%;"
                            *ngIf="adjustVoidTimesheetForm.get('timeIn')?.errors?.['customError']">
                            <div class="error-message">
                                {{adjustVoidTimesheetForm.get('timeIn')?.errors?.['customError']}}
                            </div>
                        </div>
                    </td>
                    <td>
                        <div [ngClass]="{ 'error-border': adjustVoidTimesheetForm.get('timeOut')?.errors?.['customError'] }">
                            <ppl-timepicker formControlName="timeOut" id="timeOut" [ariaLabel]="'Time Out'"
                            [placeholder]="'HH:MM AM/PM'"></ppl-timepicker>
                        </div>
                        @if(actionType === 'adjustTimesheet' || actionType === 'resurrectTimesheet') {
                        <div class="pt-4 pl-2"><span>{{timesheetData?.timeOut}}</span></div>
                        }
                        <div style="margin-left: 8px; margin-right: 8px;width: 100%;"
                            *ngIf="adjustVoidTimesheetForm.get('timeOut')?.errors?.['customError']">
                            <div class="error-message">
                                {{adjustVoidTimesheetForm.get('timeOut')?.errors?.['customError']}}
                            </div>
                        </div>
                    </td>
                    <td>
                        <input formControlName="billedUnits" nz-input id="billedUnits" aria-label="Billed Units (15 Mins increment)" />
                    </td>
                    }

                    @if (source == 'billing' && actionType == 'adjustAllBillings') {
                    <td>
                        <div style="width: 100%;" class="filters" [ngClass]="{'error': adjustVoidTimesheetForm.get('mcoName')?.invalid && adjustVoidTimesheetForm.get('mcoName')?.touched }">
                            <ppl-dropdown-select formControlName="mcoName" id="mcoName" placeholder="MCO"
                            [options]="mcoList" [optionLabel]="'orgName'" [optionValue]="'orgName'">
                            </ppl-dropdown-select>
                        </div>
                        <div style="margin-left: 8px; margin-right: 8px;width: 100%;"
                            *ngIf="adjustVoidTimesheetForm.get('mcoName')?.invalid && adjustVoidTimesheetForm.get('mcoName')?.touched">
                            <div class="error-message">Please select a MCO</div>
                        </div>

                        <div class="pt-4 pl-3"><span>{{timesheetData?.mcoName?.lkpValueName}}</span></div>
                    </td>
                    }
                    <td>
                        <div style="width: 100%;" class="filters" [ngClass]="{'error': adjustVoidTimesheetForm.get('reason')?.invalid && adjustVoidTimesheetForm.get('reason')?.touched }">
                            <ppl-dropdown-select formControlName="reason" id="reason" placeholder="Select Reason"
                            [options]="reasonList" [optionLabel]="'lkpValueName'">
                            </ppl-dropdown-select>
                        </div>
                        <div style="margin-left: 8px; margin-right: 8px;width: 100%;"
                            *ngIf="adjustVoidTimesheetForm.get('reason')?.invalid && adjustVoidTimesheetForm.get('reason')?.touched">
                            <div class="error-message">Please select a reason.</div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="this.actionType === 'adjustAllTimesheet' || 
        this.actionType === 'voidAllTimesheets' || 
        this.actionType === 'voidAllBillings' ||
        this.actionType === 'adjustAllBillings' || 
        this.actionType === 'resurrectAllTimesheet'" class="alert alert-warning">
            <strong>{{this.message}}</strong>
        </div>
        <div class="custom-row w-100">
            <ppl-button (click)="onSave()" style="margin-right: 8px;" label={{buttonLabel}} icon="fa fa-check-circle"
                [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
        </div>
    </form>
</div>